<template>
  <div id="article">
    <div class="container">
      <div class="container__article clear">
        <article-content v-if="content" :data="content" :pageIndex="currentIndex" />
      </div>
    </div>
  </div>
</template>

<script>
import ArticleContent from './components/article-content'
import types from '@/views/Article/store/types'
import { mapState } from 'vuex'
import titleMixin from '@/util/title'

export default {
  name: 'article',
  mixins: [titleMixin],
  title() {
    return this.data.title
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  components: {
    ArticleContent
  },
  asyncData({ store, route }) {
    const { dispatch } = store
    return Promise.all([dispatch(types.GET_ARTICLE_INFO, { route })])
  },
  computed: {
    ...mapState({
      data: state => state.Article.data,
      content: state => state.Article.content,
      leftList: state => state.Article.leftList
    })
  },
  methods: {
    setCurrentQuestion(index) {
      this.currentIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
.container {
  min-width: 1200px;
}
.container__article {
  width: 1200px;
  min-height: 300px;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// ./src/views/Article/index.vue